import { Box, Text } from '@redbubble/design-system';
import * as constants from '@redbubble/design-system/react/constants';
import { FormattedMessage, FormattedNumber } from '@redbubble/next/intl';
import React from 'react';

import styles from './PageHeading.module.scss';

export interface PageHeadingProps {
  lineItemsCount: number;
  total: { amount: number; currency: string };
  showInclVatText?: boolean;
}

const Separator = () => <span className={styles.separator} />;

export const PageHeading = ({ lineItemsCount, total }: PageHeadingProps) => (
  <Box className={styles.wrapper} display="flex">
    <Text element="h1" type="display2" textAlign={constants.CENTER}>
      <FormattedMessage defaultMessage="Shopping Cart" />
    </Text>
    {lineItemsCount > 0 ? (
      <Box
        className={styles.details}
        display="flex"
        flexDirection="row"
        justifyContent="center"
      >
        <Text muted type="body">
          <FormattedMessage
            defaultMessage="{cartItemsCount} {cartItemsCount, plural, one {item} other {items}}"
            values={{
              cartItemsCount: lineItemsCount,
            }}
          />
        </Text>
        <Separator />
        <Text muted type="body">
          <FormattedNumber
            value={total.amount}
            style="currency"
            currency={total.currency}
          />
        </Text>
      </Box>
    ) : null}
  </Box>
);
